import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useServices, useStores } from 'index';
import { getErrorMessage } from 'utilities/ErrorHelper';
import { adminLegendImagesV2QueryKey } from './useLegendImagesV2';

export const useUploadLegendImageV2 = () => {
  const service = useServices().trackmanParametersV2Service;
  const queryClient = useQueryClient();
  const notificationsStore = useStores().notificationStore;

  return useMutation({
    mutationFn: (file: File) => service.uploadLegendImage(file),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: adminLegendImagesV2QueryKey });
    },
    onError: (error) => notificationsStore.addToast('error', getErrorMessage(error), 'error'),
  });
};
